import { action, makeObservable, observable, when } from 'mobx';

export class OnlineStatusStore {
  public online = true;

  constructor() {
    makeObservable<OnlineStatusStore, 'setOnline'>(this, {
      online: observable,
      setOnline: action,
    });

    window.addEventListener('online', () => this.setOnline(true));
    window.addEventListener('offline', () => this.setOnline(false));
  }

  public waitOnline = () =>
    new Promise((resolve) =>
      when(
        () => this.online,
        () => resolve(undefined)
      )
    );

  private setOnline(status: boolean) {
    this.online = status;
  }
}
